import { Component, EventEmitter, Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';

import { ProjectItem } from './project/index';
import { AuthService, IUserInfo } from './shared/core/index';
import { ILookup, LookupList } from './shared/lookup';
import { CISignedUrl, CIAsset } from './clearance-item/clearance-item.model';
import { HttpService } from './shared/core/http.service';

import * as _ from 'lodash';

//declare var apiSessionId: any;
//
@Injectable()
export class AppService {    
    public listViewURL: string;
    private userPrefUrl = new URL('userprefs', this._authService.API_URL).toString();
    private searchAPIUrl = new URL('search', this._authService.API_URL).toString();
    private awsServiceAPIUrl = new URL('aws/sign', this._authService.API_URL).toString();
    private lookupsAPIUrl = new URL('lookups', this._authService.API_URL).toString();
    private emailServiceAPIUrl = new URL('email', this._authService.API_URL).toString();
    public scrollBottomReachedEvent: EventEmitter<void> = new EventEmitter<void>();
    private _isProjectLoaded: boolean = true;
    private _isDownloadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    downloadingObservable = this._isDownloadingSubject.asObservable();
    downloadQueue: string[] = [];

    constructor(private _http: Http, private _authService: AuthService, private _httpService: HttpService) {

    }
    getUserPreferences(): Observable<ProjectItem[]> {

        console.log('AppService.getUserPreferences()...');
        let userRoles = this._authService.userRoles; 
        let headers = new Headers({ 'Authorization': 'Bearer ' + this._authService.accessDetails.access_token });
        //return this._http.get(this.userPrefUrl + '?userId=' + this._authService.userInfo.userId + '&projectId=&isDashboard=false', { headers })
        return this._httpService.httpGet(this.userPrefUrl + '?userId=' + this._authService.userInfo.userId + '&projectId=&isDashboard=false', userRoles)
            .map((response: Response) => {
                // console.log('AppService.getUserPreferences() >> projects:' + JSON.stringify(response.json()));
                return <ProjectItem[]>response.json();
            })
            .do(data => data)
        // .catch(this.handleError);
    }

    getDashboardProject(projectId: string): Observable<ProjectItem[]> {
        
        let userRoles = this._authService.userRoles; 
        console.log('AppService.getDashboardProject(' + projectId + ')...');
        let headers = new Headers({ 'Authorization': 'Bearer ' + this._authService.accessDetails.access_token });
        //return this._http.get(this.userPrefUrl + '?userId=' + this._authService.userInfo.userId + '&projectId=' + projectId + '&isDashboard=true', { headers })
        return this._httpService.httpGet(this.userPrefUrl + '?userId=' + this._authService.userInfo.userId + '&projectId=' + projectId + '&isDashboard=true', userRoles)
            .map((response: Response) => {
                //console.log('response.json():' + JSON.stringify(response.json()));
                return this.toProject(response.json());// <ProjectItem[]>response.json();
            })
            .do(data => data)
            .catch(this.handleError);
    }

    toProject(r: any): ProjectItem[] {

        // console.log('r:' + JSON.stringify(r));

        let retProjects = new Array<ProjectItem>();

        r.forEach(element => {
            let p = <ProjectItem>element;

            p.NewCICount = this.aggregateByStatus(p.CICount, 'NEW');
            //process 'PENDINGS'
            p.AllPendingCICount = this.aggregateByStatus(p.CICount, 'PENDING');
            p.PendingByProductionCICount = this.aggregateByStatus(p.CICount, 'PENDING - Updated by Production');
            p.PendingMoreInfoCICount = this.aggregateByStatus(p.CICount, 'PENDING - Production Info Required');
            p.PendingReleaseNeededCICount = this.aggregateByStatus(p.CICount, 'PENDING - Release Needed');
            p.AdPubCICount = this.aggregateByStatus(p.CICount, 'RESTR_Ad/Pub');
            p.ArtCICount = this.aggregateByStatus(p.CICount, 'TAG_Art Department');
            p.PropsCICount = this.aggregateByStatus(p.CICount, 'TAG_Props');
            p.SetDecCICount = this.aggregateByStatus(p.CICount, 'TAG_Set Dressing');
            p.WardrobeCICount = this.aggregateByStatus(p.CICount, 'TAG_Wardrobe');
            p.PostCICount = this.aggregateByStatus(p.CICount, 'TAG_Post');
            p.ScriptCICount = this.aggregateByStatus(p.CICount, 'TAG_Script');
            p.LocationCICount = this.aggregateByStatus(p.CICount, 'TAG_Location');
            p.ResearchCICount = this.aggregateByStatus(p.CICount, 'TAG_Research');
            //p.MarketingCICount = this.aggregateByStatus(p.CICount, 'TAG_Marketing');
            p.EndCreditCICount = this.aggregateByStatus(p.CICount, 'RESTR_End credit');
            p.StatusChangeCICount = this.aggregateByStatus(p.CICount, 'CHGSTATUS');
            p.ClipCICount = this.aggregateByStatus(p.CICount, 'TAG_Clip');
            p.MaterialReleaseCICount = this.aggregateByStatus(p.CICount, 'TAG_Material Release');
            p.ArtistCertificateCICount = this.aggregateByStatus(p.CICount, 'TAG_Artist Certificate');
            p.PhotoReleaseCICount = this.aggregateByStatus(p.CICount, 'TAG_Photo Release');
            p.ProductPlacementCICount = this.aggregateByStatus(p.CICount, 'TAG_Product Placement');
            p.MainCharacterCICount = this.aggregateByStatus(p.CICount, 'TAG_Character - Main');
            p.SecondaryCharacterCICount = this.aggregateByStatus(p.CICount, 'TAG_Character - Secondary');
            p.IncidentalCharacterCICount = this.aggregateByStatus(p.CICount, 'TAG_Character - Incidental');
            p.EffectsCICount = this.aggregateByStatus(p.CICount, 'TAG_Effect');
            p.CrowdCICount = this.aggregateByStatus(p.CICount, 'TAG_Crowd');
            p.MouthChartCICount = this.aggregateByStatus(p.CICount, 'TAG_Mouth Chart');
            p.SpecialPoseCICount = this.aggregateByStatus(p.CICount, 'TAG_Special Pose');
            p.SizeCompCICount = this.aggregateByStatus(p.CICount, 'TAG_Size Comp');
            p.CLRCount = this.aggregateByStatus(p.CICount, 'TAG_CLR');
            p.DigimatteCount = this.aggregateByStatus(p.CICount, 'TAG_Digimatte');
            p.GraphicCount = this.aggregateByStatus(p.CICount, 'TAG_Graphic');
            p.ContactTitle = p.ContactTitle;
            p.ContactName = p.ContactName;
            p.ContactEmail = p.ContactEmail;
            p.ContactPhoneNumber = p.ContactPhoneNumber;

            retProjects.push(p);
        });

        return retProjects;
    }

    private aggregateByStatus(ciCounts: Map<string, number>, statusOrKey: string): number {

        var myKeys = Object.keys(ciCounts);

        var matchingKeys = myKeys.filter(function (key) { return key.indexOf(statusOrKey) !== -1 });

        let retValue: number = 0;

        matchingKeys.forEach(k => {
            retValue += ciCounts[k];
        }
        );

        return retValue;
    }

    addFavorite(project: ProjectItem): Observable<Boolean> {

        project.PreferenceType = 'Favorite Project';
        let headers = new Headers({ 'Authorization': 'Bearer ' + this._authService.accessDetails.access_token });
        //return this._http.post(this.userPrefUrl, project, { headers })
        return this._httpService.httpPost(this.userPrefUrl, project, this._authService.userRoles)
            .map((response: Response) => {
                return response.status == 200;
            })
            .do(data => data)
        // .catch(this.handleError);
    }

    addRecent(project: ProjectItem): Observable<ProjectItem> {

        
        let userRoles = this._authService.userRoles; 
        project.PreferenceType = 'Recent Project';
        project.SortOrder =1;
        project.UserId = this._authService.userInfo.userId;
        var body = JSON.stringify(project);
        return this._httpService.httpPost(this.userPrefUrl, project, userRoles)
            .map((response: Response) => {
                return response.json();
            })
            .do(data => data)
        // .catch(this.handleError);
    }

    deleteFavorite(project: ProjectItem): Observable<Boolean> {

        let headers = new Headers({ 'Authorization': 'Bearer ' + this._authService.accessDetails.access_token });
        //return this._http.delete(this.userPrefUrl + '?userId=' + this._authService.userInfo.userId + '&projectId=' + project.ProjectId, { headers })
        return this._httpService.httpDelete(this.userPrefUrl + '?userId=' + this._authService.userInfo.userId + '&projectId=' + project.ProjectId)
            .map((response: Response) => {
                return response.status == 200;
            })
            .do(data => data)
            .catch(this.handleError);
    }

    search(terms: Observable<string>, isExactMatch = false, debounceDuration = 100): Observable<ProjectItem[]> {
        return terms.debounceTime(debounceDuration)
            .distinctUntilChanged()
            .switchMap(term => this.rawSearch(isExactMatch, term))
            .catch((e) => {
                // handle e and return a safe value or rethrow
                console.error('error on AppService.search(): ' + JSON.stringify(e));
                return Observable.of<any>([]);
            });
    }

    rawSearch(isExactMatch: boolean, term: string, searchByCode: boolean = false): Observable<ProjectItem[]> {

        let token = this._authService.accessDetails.access_token;

        var headers = new Headers({ 'Authorization': 'Bearer ' + token });
        
        //return this._http.get(this.searchUrl + '?projectName=' + encodeURI(term) + '&exactMatch=' + isExactMatch.toString() + '&byCode=' + searchByCode, { headers })
        return this._httpService.httpGet(this.searchAPIUrl + '?projectName=' + encodeURI(term) + '&exactMatch=' + isExactMatch.toString() + '&byCode=' + searchByCode)
            .map((response) => {
                // console.log('rawSearch ' );
                
                var result = <ProjectItem[]>response.json();
                return result;
            }
            )
            .do(data => data)
            .catch(this.handleError);
    }

    private ciLookups: LookupList[];

    retrieveCILookups(lookups: string = 'CIStatus,Tags,CIRestrictions', projectId: string = '', forceRefresh: boolean = false): Observable<LookupList[]> {
        ;
        // console.log('AppService.retrieveCILookups()');

        let requestedLookups = lookups.split(',');

        if (!projectId && !forceRefresh && this.ciLookups != null && this.ciLookups.length > 0 && _.difference(requestedLookups, Array.prototype.map.call(this.ciLookups, s => s.lookupType)).length === 0) {
            // console.log('AppService.retrieveCILookups() >> returning with existing cache of lookups: ' + JSON.stringify(this.ciLookups));
            return Observable.of(this.ciLookups);
        }
        else {
            // console.log('AppService.retrieveCILookups(), calling ' + this.lookupsUrl + ' with lookupTypes=' + lookups)
            /* return this._http.get(this.lookupsUrl + '?lookupTypes=' + lookups+'&projectId=' + projectId, {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this._authService.accessDetails.access_token
                })
            }) */
            return this._httpService.httpGet(this.lookupsAPIUrl + '?lookupTypes=' + lookups+'&projectId=' + projectId)
                .map((response: Response) => {
                    this.ciLookups = <LookupList[]>response.json();
                    return this.ciLookups;

                })
                // .do(data => data)
                // .catch(this.handleError);
        }

    }
    downloadReport(projectId: string): Observable<Blob> {
        var url = "http://adsscrimsjsreport-env.2cjezmpdiu.us-west-1.elasticbeanstalk.com/api/report";
        var body = { "template": { "shortid": "BkVlg9wd-" }, "data": { "projectId": projectId } };
        return this._http.post(url, body, { responseType: ResponseContentType.Blob })
            .map(
                (res) => {
                    return new Blob([res.blob()], { type: 'application/pdf' })
                })
            .do(data => data)
            .catch(this.handleError);;
    }

    private handleError(error: Response) {

        console.log('AppService.handleError() >> error:' + error);
        return Observable.throw(error || 'Server error');
    }

    getSignedUrl(file: string, project: string, method: string, type: string, ownerType: string, name: String): Observable<CISignedUrl> {
        
        let paramName ='';
        if (name != ''){
            paramName = '&n=' + name;
        }
        console.log('ClearanceItemService.getSignedUrl >> Url: ' + this.awsServiceAPIUrl + '?f=' + file + '&p=' + project + '&o=' + ownerType + paramName);

        /* return this._http.get(this.awsServiceUrl + '?f=' + file + '&p=' + project + '&m=' + method + '&t=' + type + '&o=' + ownerType + paramName, {
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this._authService.accessDetails.access_token
            })
        }) */
        return this._httpService.httpGet(this.awsServiceAPIUrl + '?f=' + file + '&p=' + project + '&m=' + method + '&t=' + type + '&o=' + ownerType + paramName)
            .map((response: Response) => {
                //return response.text();
                var result = response.json();
                return result;
            })
            .do(data => data)
            .catch(this.handleError);
    }

    getSignedUrlInline(file: string, project: string, method: string, type: string, ownerType: string, name: String): Observable<CISignedUrl> {
        let paramName ='';
        if (name != ''){
            paramName = '&n=' + name;
        }
        console.log('ClearanceItemService.getSignedUrlInline >> Url: ' + this.awsServiceAPIUrl + '?f=' + file + '&p=' + project + '&o=' + ownerType + paramName);
        return this._httpService.httpGet(this.awsServiceAPIUrl+'/inline' + '?f=' + file + '&p=' + project + '&m=' + method + '&t=' + type + '&o=' + ownerType + paramName)
            .map((response: Response) => {
                var result = response.json();
                return result;
            })
            .do(data => data)
            .catch(this.handleError);
    }

    getFileAs(file: CIAsset): Observable<Blob> {

        return this._http.get(file.fullUrl, {
                responseType: ResponseContentType.Blob
            })
            .map((response: Response) => {
                return new Blob([response.blob()], { type: file.fileType })
            })
            .catch(this.handleError);
    }

    sendNewUserEmail(email: string): Observable<boolean> {
        console.log('EmailService.SendNewUserEmail >> Url: ' + this.emailServiceAPIUrl + '/newuser?email=' + email);
        return this._httpService.httpGet(this.emailServiceAPIUrl + '/newuser?email=' + email)
            .map((response: Response) => {
                return response.json();
            })
            .catch(this.handleError);
    }

    getReferenceDocuments(projectId: string): Observable<any[]> {
        let file='.';
        let method = 'GET';
        let type = 'ref';
        let ownerType = 'ref';
        let name = ''
        let paramName ='';
        if (name != ''){
            paramName = '&n=' + name;
        }
        console.log('ClearanceItemService.getSignedUrl >> Url: ' + this.awsServiceAPIUrl+'/helpdocsreference' + '?f=' + file + '&p=' + projectId + '&o=' + ownerType + paramName);

        return this._httpService.httpGet(this.awsServiceAPIUrl+'/helpdocsreference' + '?f=' + file + '&p=' + projectId + '&m=' + method + '&t=' + type + '&o=' + ownerType + paramName)
            .map((response: Response) => {
                var result = response.json();
                return result;
            })
            .do(data => data)
            .catch(this.handleError);
    }

    get isProjectLoaded():boolean{
        return this._isProjectLoaded;
    }

    set isProjectLoaded(value : boolean){
        this._isProjectLoaded = value;
    }
    
    get isDownloading():boolean{
        return this.downloadQueue.length>0
    }

    enqueueDownload(filename: string){
        this.downloadQueue.push(filename);
        this._isDownloadingSubject.next(true);
        
    }

    removeFromDownloadQueue(fileName){
        let i = this.downloadQueue.indexOf(fileName);
        if (i !== -1) {
            this.downloadQueue.splice(i, 1);
        }
        this._isDownloadingSubject.next(this.downloadQueue.length>0);
    }

    get downloadFileNames():string[]{
        return this.downloadQueue;
    }
}




// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/app.service.ts